import { render, staticRenderFns } from "./laboratoire-imagerie.html?vue&type=template&id=1618e632&scoped=true&external"
import script from "./laboratoire-imagerie.js?vue&type=script&lang=js&external"
export * from "./laboratoire-imagerie.js?vue&type=script&lang=js&external"
import style0 from "./laboratoire-imagerie.scss?vue&type=style&index=0&id=1618e632&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618e632",
  null
  
)

export default component.exports